export default {
  'FAQ' (state) {
    return state.faq
  },
  'FAQS' (state) {
    return state.faqs
  }
}
